import { css } from '@emotion/react';

export default css({
  '&.number-input': {
    position: 'relative',
  },
});
